export const SET_SHOW_WELCOME_MODAL = "SET_SHOW_WELCOME_MODAL"

export const setShowWelcomeModal = (action) => {
  return {
    type: SET_SHOW_WELCOME_MODAL,
    action
  }
}
